export const rtlLocales = ['ar']
